import { FC } from 'react'
import { useStores } from '@/utils'
import { observer } from 'mobx-react'
import styles from './index.module.scss'

export const AdContactBtnGroup: FC = observer(() => {
  const { ui } = useStores()
  const toggleAdContactFormModalOpen = () => {
    ui.toggleAdContactFormModalOpen()
  }
  return (
    <div className={styles.container}>
      <div className={styles.heading}>Ready to get started?</div>
      <button type='button' onClick={toggleAdContactFormModalOpen} className={styles.btn}>
        <div className={styles.btnText}>Contact</div>
      </button>
    </div>
  )
})
